import type { Dayjs } from "dayjs";
import { uniq } from "lodash-es";

import type { FlightType } from "@/features/flights/types/types";
import { determineCabinClasses } from "@/features/flights/utils/cabinClasses";
import type {
  FindFlightOffersFlightSegmentV3,
  FindFlightOffersOfferItemV3,
  GetFlightAvailabilityTokenCabinClassV2,
} from "@/types/codegen";

export const mapCabinClasses = (
  segment: FindFlightOffersFlightSegmentV3,
  offerItems?: FindFlightOffersOfferItemV3[],
) => {
  const cabinClassesInfo = offerItems
    ?.map((offerItem) => ({
      quantity: offerItem.count,
      ptc: offerItem.ptc,
      type: offerItem.fareComponents.find(
        (fareComponent) => fareComponent.segmentIndex === segment.index,
      )?.cabinTypeCode,
    }))
    .filter(
      (
        cabinClassInfo,
      ): cabinClassInfo is GetFlightAvailabilityTokenCabinClassV2 =>
        cabinClassInfo.type !== undefined,
    );

  const cabinClasses = cabinClassesInfo
    ? determineCabinClasses(cabinClassesInfo)
    : [];

  return cabinClasses;
};

export const isStopOvernight = (
  beginningOfStop: Dayjs,
  stopLength: { hours: number; minutes: number },
) => {
  const endOfStop = beginningOfStop
    .add(stopLength.hours, "hour")
    .add(stopLength.minutes, "minute");
  return (
    endOfStop.startOf("day").diff(beginningOfStop.startOf("day"), "day") > 0
  );
};

export const getNumberOfCarriersHandlingFlight = (flight: FlightType) => {
  const a = flight.segments.flatMap((segment) => [
    segment.marketingCarrier.airline.code,
    segment.operatingCarrier.airline.code,
  ]);

  return uniq(a).length;
};
